export const globalLogsSagaActionTypes = {
  callGetGlobalLogsSaga: "callGetGlobalLogsSaga",
};

export const getGlobalLogsSagaAction: (logType: string) => {
  type: string;
  logType: string;
} = (logType) => {
  return {
    type: globalLogsSagaActionTypes.callGetGlobalLogsSaga,
    logType,
  };
};
